<p class="highcharts-title ehs-title">
        Process Safety
    </p>
    <p class="ehs-sub-title">
        {{ehs_Process_Text}}
    </p>
    <p style=" padding: 0px; width: 100%; text-align: center; margin: 0px;">
        <highcharts-chart *ngIf="ehsChart" [Highcharts]="Highcharts" [options]="ehsChart"></highcharts-chart>
        <span class="comment"
            style="text-align: center; width: 100%;font-size:medium;">
            <em><b>{{ehs_CurrentYear-1}}:&nbsp;</b></em>{{ehs_Process_LastYearValue}}<br>
            <em><b>{{ehs_CurrentYear}}:&nbsp;</b></em>{{ehs_Process_CurrentYearValue}} YTD
        </span>
    </p> 